import { FC } from 'react';
import { Progress } from '../../types';
import styles from './ProgressBar.module.css';

export interface ProgressBarProps extends Progress {}

export const ProgressBar: FC<ProgressBarProps> = ({ progress = 0, total }) => {
  const progressPercentage = Math.round((progress / total) * 100);
  return (
    <div className={styles.progressBar}>
      <div
        className={styles.progressMarker}
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
};
